import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSend, FiFilter, FiTrendingUp, FiVideo, FiUsers, FiMessageSquare, FiCalendar, FiBarChart3 } = FiIcons;

const FeatureBlocks = () => {
  const features = [
    {
      icon: FiSend,
      title: 'Publish & Automated Shortlisting',
      description: 'One-click job posting across multiple channels with instant candidate filtering'
    },
    {
      icon: FiFilter,
      title: 'Smart Candidate Filtering',
      description: 'Advanced filters and matching algorithms to surface the best candidates'
    },
    {
      icon: FiTrendingUp,
      title: 'AI Scoring & Insights',
      description: 'Comprehensive candidate scoring with detailed insights and recommendations'
    },
    {
      icon: FiVideo,
      title: 'AI Video Interviews',
      description: 'Automated video interviews with AI analysis and proxy detection'
    },
    {
      icon: FiUsers,
      title: 'Multi-Select & Batch Launch',
      description: 'Efficiently manage multiple candidates and launch batch processes'
    },
    {
      icon: FiMessageSquare,
      title: 'Panel Collaboration & Feedback Loop',
      description: 'Seamless collaboration tools for hiring panels with structured feedback'
    },
    {
      icon: FiCalendar,
      title: 'Scheduling & Candidate Experience',
      description: 'Streamlined scheduling with exceptional candidate communication'
    },
    {
      icon: FiBarChart3,
      title: 'Analytics & Decision Support',
      description: 'Data-driven insights to optimize your hiring process and decisions'
    },
    {
      icon: FiBarChart3,
      title: 'Staffing Partner Support',
      description: 'End-to-end staffing partner support to streamline hiring operations, recruitment efficiency.'
    }
  ];

  return (
    <section id="features" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="font-display font-bold text-3xl lg:text-5xl text-slate-900 mb-6">
            Everything you need to hire smarter
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Comprehensive tools designed to streamline every step of your recruitment process
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="bg-white border border-slate-200 rounded-2xl p-8 shadow-elegant shadow-hover hover:border-indigo-200 transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="w-14 h-14 bg-indigo-100 rounded-lg flex items-center justify-center mb-6">
                <SafeIcon icon={feature.icon} className="w-7 h-7 text-indigo-600" />
              </div>
              
              <h3 className="font-semibold text-xl text-slate-900 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-slate-600 leading-relaxed mb-4">
                {feature.description}
              </p>
              
              <button className="text-indigo-600 font-medium hover:text-indigo-700 transition-colors">
                See demo →
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureBlocks;